import { axios } from '@/lib/axios';

export const getMenuByLocation = async (locationId: number, callbackFn?: () => void) =>
    await axios
        .get(`v1/get-menus-by-location/${locationId}`)
        .then((res) => res?.data?.menus)
        .catch((err) => {
            console.log('error from get-menus-by-location', err), callbackFn && callbackFn();
        });
